/**
 * Build the desktop document route, preserving opaque location identities.
 * `projectId` lets desktop pick the workspace bound to the page's project
 * rather than the first workspace in the org.
 */
export function buildDocumentDesktopLink(documentId: string, orgId: string, search = '', projectId?: string): string {
  const source = new URLSearchParams(search);
  const params = new URLSearchParams({ orgId });
  if (projectId) params.set('projectId', projectId);
  for (const key of ['blockId', 'threadId', 'commentId'] as const) {
    const value = source.get(key);
    if (value !== null) params.set(key, value);
  }
  return `nimbalyst://doc/${encodeURIComponent(documentId)}?${params}`;
}
